import { FEATURE_APP_ID } from '@client-hub/shared/constants/feature-hub'
import MfeLoader from '@client-hub/shared/react/components/MfeLoader'

const Dashboard = () => <MfeLoader port={process.env.NX_DASHBOARD_MFE_PORT!} mfeId={FEATURE_APP_ID.DASHBOARD_MFE} />

export default Dashboard
